import type { EmailThread } from '@core/types';
import { emailDeliveryKind, emailDeliveryLabel } from './emailDeliveryUi';

function triggerDownload(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

function csvEscapeCell(v: string): string {
  if (/[,"\r\n]/.test(v)) return `"${v.replace(/"/g, '""')}"`;
  return v;
}

export function downloadEmailThreadsCsv(rows: EmailThread[]) {
  const headers = [
    'id',
    'subject',
    'recipient_email',
    'client',
    'candidate',
    'job',
    'delivery',
    'response',
    'opens',
    'sent_at',
    'created_at',
  ];
  const headerLine = headers.join(',');
  const lines = rows.map((t) => {
    const app = t.application as
      | { client?: { name: string }; candidate?: { full_name: string }; job?: { title: string } }
      | undefined;
    const cells = [
      t.id,
      t.subject ?? '',
      t.recipient_email ?? '',
      app?.client?.name ?? t.recipient_name ?? '',
      app?.candidate?.full_name ?? '',
      app?.job?.title ?? '',
      emailDeliveryLabel(emailDeliveryKind(t)),
      t.cta_response ?? '',
      String(t.open_count ?? 0),
      t.sent_at ?? '',
      t.created_at ?? '',
    ];
    return cells.map((x) => csvEscapeCell(String(x))).join(',');
  });
  const content = '\ufeff' + [headerLine, ...lines].join('\n');
  const stamp = new Date().toISOString().slice(0, 10);
  const blob = new Blob([content], { type: 'text/csv;charset=utf-8' });
  triggerDownload(blob, `email-threads-${stamp}.csv`);
}
